// @core/api/endpoints/team/cancel_team_join_application.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CancelTeamJoinApplicationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Cancel join application
 * Cancels a pending join application. Only the original applicant can cancel their own application.
 */
export async function CancelTeamJoinApplication(
  application_id: string,
  data: CancelTeamJoinApplicationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/join-applications/:application_id/cancel`;
  requestPath = requestPath.replace(':application_id', encodeURIComponent(application_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
